import React, { useEffect } from 'react';
import { AuthUser } from '~redux/auth/actions/authUser';
import { ProductReadModel } from '~types/api';
import { pushViewItemListEvent } from '~utils/gtm';
import { getPublicImageUrl } from '~utils/image';
import { calculatePrice } from '~utils/price';
import { productListFiltered, productListViewed } from '~utils/segment';

export type SearchCategory = {
  summaryCategory?: string;
  categories: Category[];
};

export type Category = {
  mainCategory: string;
  subCategory?: string;
};

type ListViewLoggerProps = {
  listId?: string;
  products: ProductReadModel[];
  index: number;
  user?: AuthUser;
  searchCategory?: SearchCategory;
  category?: string;
  subCategory?: string;
  brand?: string;
  search_type?: string;
  keywords?: string[];
  tags?: string[];
  sort?: string;
  sortState?: { field: string; direction: 'desc' | 'asc' };
  filters?: { type: string; value: any }[];
  sorts?: { type: string; value: string }[];
};

const getCategory = (searchCategory?: SearchCategory) => {
  let category: string | undefined = undefined;
  let subCategory: string | undefined = undefined;

  if (searchCategory) {
    if (searchCategory.summaryCategory) {
      category = searchCategory.summaryCategory;
    } else {
      if (searchCategory.categories.length > 0) {
        category = searchCategory.categories[0].mainCategory;
        subCategory = searchCategory.categories[0].subCategory;
      }
    }
  }

  return [category, subCategory];
};

const ListViewLogger: React.FC<ListViewLoggerProps> = ({
  listId,
  products,
  index,
  user,
  searchCategory,
  category,
  subCategory,
  brand,
  search_type,
  keywords,
  tags,
  sort,
  sortState,
  filters,
  sorts,
}) => {
  if (!category) {
    [category, subCategory] = getCategory(searchCategory);
  }

  useEffect(() => {
    pushViewItemListEvent({
      items: products.map((item, i) => ({
        item_name: item.product_name!,
        item_id: item.id!,
        price: calculatePrice(
          item.product_retail_price!,
          item.product_sale_wholesale_rate ?? item.product_wholesale_rate!
        ),
        item_brand: item.brand_name!,
        item_category: item.product_category!,
        item_category2: item.product_subcategory!,
        item_list_name: document.title,
        item_list_id: listId ?? location.pathname,
        index: index + i,
        quantity: 1,
      })),
      user,
      category,
      sub_category: subCategory,
      brand,
      search_type,
      keywords,
      tags,
      sort,
    });
  }, [products, listId]);

  useEffect(() => {
    const items = products.map((product, i) => ({
      brand_id: product.brand_id!,
      brand: product.brand_name!,
      category: `${product.product_category}/${product.product_subcategory}`,
      image_url: getPublicImageUrl(product.image_key),
      name: product.product_name!,
      position: index + i + 1,
      price: calculatePrice(
        product.product_retail_price!,
        product.product_sale_wholesale_rate ?? product.product_wholesale_rate!
      ),
      product_id: product.id!,
      // quantity: 1,
      sku: product.product_number!,
      url: `${document.location.protocol}//${document.location.host}/productdetail/${product.id}`,
      // variant: product.producttype?.[0]?.type_name ?? undefined,
    }));

    if (filters) {
      productListFiltered(
        listId ??
          (brand
            ? brand
            : subCategory
            ? `${category}/${subCategory}`
            : category ?? 'search'),
        subCategory ? `${category}/${subCategory}` : category ?? 'ALL',
        items,
        filters,
        sorts ??
          (sortState
            ? [{ type: sortState.field, value: sortState.direction }]
            : undefined)
      );
      return;
    }

    productListViewed(
      listId ??
        (brand
          ? brand
          : subCategory
          ? `${category}/${subCategory}`
          : category ?? 'search'),
      subCategory ? `${category}/${subCategory}` : category ?? 'ALL',
      items
    );
  }, [products, index, keywords, sortState, listId, category, subCategory]);

  return null;
};

export default ListViewLogger;
